import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  "cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground shadow-xs hover:bg-primary/80',
        accent: 'bg-accent text-secondary-foreground shadow-xs hover:bg-accent/20',
        secondary: 'bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80',
        destructive:
          'bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60',
        outline:
          'border bg-background shadow-xs hover:bg-accent/20 hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50',
        ghost: 'hover:bg-accent/20 hover:text-accent-foreground dark:hover:bg-accent/50',
        link: 'text-primary underline-offset-4 hover:underline',
        navLeft:
          'hover:bg-secondary text-primary-900 rounded-md hover:bg-muted/80 focus-visible:ring-primary/60 aria-selected:bg-primary aria-selected:text-white disabled:bg-muted disabled:text-muted-foreground',
        navRight:
          'hover:bg-secondary text-primary-900 rounded-md hover:bg-muted/80 focus-visible:ring-primary/60 aria-selected:bg-primary aria-selected:text-white disabled:bg-muted disabled:text-muted-foreground',
        unstyled: '',
      },
      size: {
        default: 'h-9 px-4 py-2 has-[>svg]:px-3',
        sm: 'h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5',
        lg: 'h-10 rounded-md px-6 has-[>svg]:px-4',
        icon: 'size-9',
        /** Use when the Button needs no built-in size constraints (e.g. inline triggers, table sort headers). */
        unstyled: '',
      },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  }
);
